import React from 'react';
import { TRACKING_MSG_TYPE, TRACKING_TYPE, BANK_POLICY_CONTENT, TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET } from '@/utils/constants';
import { inject, observer } from 'mobx-react';
import { ReactSVG } from 'react-svg';

import Msg from '@/components/Msg';
import SingleButton from '@/components/SingleButton';
import { handleLiveBtnClick, trackingHandler } from '@/utils/btnClickHandler';
import { tracker, dispatchTrack } from '@/utils/tracking';
import { getChildInject, getTrans } from '@/utils/instantLoaded/tools';
import { hideDialogueChannelOptionButton, updateDialogueInfo, addDialogue, disableDialogueChannelOptionButton } from '@/utils/sessionUtils';
import Chat from '@/assets/img/chat.svg';
import { handleJoinedQueue } from './handleJoinedQueue';
import { LiveComponentFromDialogueSource, HAS_SCROLL_TO_END } from './constants';
import { ButtonGroup, Popup, InfiniteScroll } from '@shopee/chatbot-ui';
import EnquiryCaseCard from '@/components/EnquiryCaseCard';
import { DIALOGUE_FROM, DIALOGUE_TYPE } from '@/types/common';
import { redirectionTo } from '@/utils/tools';
import { getWebFormKey, hasWebForm, startAgent } from '@/utils/agent';
import API, { IsAnyLiveAgentAvailableEnum } from '@/services';
import uploadMessageToSave from '@/utils/uploadMessageToSave';
import dateLib from '@/utils/dateLib/moment';

import { ScrollType, ElementScrollTrackManage } from '@/utils/tracking/utils/elmentScrollTrack';

import './style.scss';
import Redirection from '../Redirection';
import { shouldApplyLiveAgentAvailbility } from '@/utils/shouldApplyLiveAgentAvailbility';

const PREFIX = 'live-container';

type CaseItem = any;

@tracker
@inject(getChildInject('initStore', 'userStore', 'agentStore', 'sessionStore'))
@observer
export default class Live extends React.PureComponent {
  state = { loading: false };

  static defaultProps = {
    // props
    msgContent: '',
    btnContent: '',
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    isCaseSelect: false,
    // enquiryCaseNum: '',
    enquiryCaseCurSize: 0,
    enquiryCaseMaxSize: 0,
    isButtonsDisabled: true,
    // stores
    initStore: {},
    userStore: {},
    agentStore: {},
    sessionStore: {},
  };

  constructor(props) {
    super(props);
    const {
      dialogueId,
      initStore,
      buttonType,
      btnContent,
      nodePointId,
      buttonId,
      isHistory,
      historyDialogueId,
      historySessionId,
      trackingname,
      // isButtonsDisabled,
      disabledBtn,
      isCaseSelect,
      sessionStore,
    } = this.props;

    this.trackingname = trackingname ?? TRACKING_TYPE.AGENT;
    this.trackingdata = {
      node_point_id: nodePointId || '',
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_type: buttonType,
      button_text: btnContent,
      button_id: buttonId || '',
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
    this.state = {
      active: false,
      caseList: [],
      isButtonsDisabled: disabledBtn,
      page_no: 2,
    };

    this.elementScrollTrack = new ElementScrollTrackManage();
    this.domRef = React.createRef();

    // tracking
    this.caseSelectorScrolls = 0;
    this.caseSelectorScrollToEnd = HAS_SCROLL_TO_END.FALSE;

    // lock
    this.dataFetching = false;
    this.hasMoreCase = true;
  }

  componentDidMount() {
    if (this.props.isCaseSelect) {
      const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId } = this.props;
      dispatchTrack({
        operation: TRACKING_OPERATION.IMPRESSION,
        section: TRACKING_SECTION[TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR],
        target: TRACKING_TARGET[TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR],
        data: {
          chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
          chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
          bot_id: kbBotId,
          if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
          case_count: enquiryCaseCurSize,
        },
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.active !== this.state.active && this.state.active) {
      this.caseSelectorScrolls = 0;
      setTimeout(() => {
        this.elementScrollTrack.addTrack(this.domRef.current, ScrollType.Vertical, {
          scrollCallback: () => {
            this.caseSelectorScrolls += 1;
          },
          // trackScrollToEnd: true,
          // scrollToEndCallBack: () => {
          //   this.caseSelectorScrollToEnd = true;
          // },
        });
      }, 0);
    }

    if (this.props?.caseActive) {
      this.handleCaseClick();
      this.props?.sessionStore.UPDATE_DIALOGUE_WHO_HAS_CHANNEL_OPTION({ caseActive: false });
    }
  }

  handleJumpClick = () => {
    const { isHistory, source, initStore, disabledBtn, isCaseSelect } = this.props;
    if (!isHistory && disabledBtn) {
      return;
    }

    if (source === LiveComponentFromDialogueSource.LiveAgentRecommender) {
      updateDialogueInfo({ isDisabled: true }, this.props.listPos);
    }

    if (source === LiveComponentFromDialogueSource.ChannelOptionLive) {
      hideDialogueChannelOptionButton();
    }

    handleJoinedQueue(initStore.sessionId);
    handleLiveBtnClick(
      {
        dialogueId: this.props.dialogueId,
        dialogueType: this.props.dialogueType,
        text: isCaseSelect ? this.props.btnContent[1] : this.props.btnContent,
        listPos: this.props.listPos,
        queue_name: isCaseSelect ? this.props.queue_name[1] : this.props.queue_name,
        user_type: isCaseSelect ? this.props.user_type[1] : this.props.user_type,
        enquiry_type: isCaseSelect ? this.props.enquiry_type[1] : this.props.enquiry_type,
        liveAgentAutoQueueInfo: this.props.liveAgentAutoQueueInfo,
        inhouseLiveAgent: this.props.liveAgentAutoQueueInfo?.inhouse_live_agent || {},
        letUserChoose: this.props.liveAgentAutoQueueInfo?.let_user_choose,
        queueType: this.props.liveAgentAutoQueueInfo?.queue_type,
        isChatbotMsgBeforeLiveAgent:
          source === LiveComponentFromDialogueSource.LiveAgentRecommender,
        isHistory,
      },
      {
        trackingname: this.trackingname,
        trackingdata: this.trackingdata,
      },
    );
  };

  handleBankJump = async (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      window.event.returnValue = false;
    }
    const { redirectionTo } = await import('@/utils/tools');
    const { BANK_POLICY_URL } = await import('@/utils/locale');
    redirectionTo(BANK_POLICY_URL[COUNTRY], undefined, { navbar: { liveChatPageType: 'bank' }});
  };

  handleLoadMore = async (enquiryCaseMaxSize: number) => {
    if (this.hasMoreCase && !this.dataFetching) {
      this.dataFetching = true;
      const params = {
        page_no: this.state.page_no,
        page_size: enquiryCaseMaxSize,
      };
      const { case_items } = await (API).queryUserCaseList(params).catch(() => {});
      this.dataFetching = false;
      const newCaseList = [...this.state.caseList].concat(...case_items);
      this.setState({
        caseList: newCaseList,
        page_no: this.state.page_no + 1,
      });
      if (!case_items?.length) {
        this.hasMoreCase = false;
        this.caseSelectorScrollToEnd = HAS_SCROLL_TO_END.TRUE;
      }
    }
  };

  handleCaseCardClick = (caseItem: CaseItem) => {
    redirectionTo('case_tracker_detail_page', { case_id: caseItem.case_id });
  };

  showAndSaveMessage = (from: string, text: string, hasOrderInfo: boolean, caseItem:CaseItem) => {
    // 回显
    addDialogue(
      {
        dialogueId: this.props.dialogueId,
        dialogueType: this.props.dialogueType,
        from,
        type: DIALOGUE_TYPE.Msg,
        data: { content: text },
      },
      false,
    );
    addDialogue(
      {
        dialogueId: this.props.dialogueId,
        dialogueType: this.props.dialogueType,
        from,
        type: DIALOGUE_TYPE.EnquiryCaseCard,
        data: {
          hasOrderInfo, caseItem, onCaseCardClick: () => {
            this.handleCaseDetailFromChatTracking(caseItem);
            this.handleCaseCardClick(caseItem);
          },
        },
      },
      false,
    );

    // 上传消息 用于记录历史消息
    uploadMessageToSave({
      dialogueId: this.props.dialogueId,
      messages: [
        {
          message_text: text,
          is_sent_by_user: from === 'user',
        },
        {
          version: 1,
          is_sent_by_user: from === 'user',
          message_content: {
            type: 'CASE_SELECT',
            case_select: {
              has_order_info: hasOrderInfo,
              case_card_title: caseItem.enquiry_type_name ? `${getTrans('case_enquiry_on')} ${caseItem.enquiry_type_name}` : `${getTrans('case_enquiry_on')} ${dateLib.format(caseItem.first_enquiry_time, 'MMM DD, HH:ii')}`,
              case_card_last_update_time: caseItem.case_update_time,
              order_img: caseItem.order_item_first_image_url,
              order_name: caseItem.order_item_name,
              order_sn: caseItem.order_sn,
              case_id: caseItem.case_id,
              first_enquiry_time: caseItem.first_enquiry_time,
              enquiry_type_name: caseItem.enquiry_type_name,
            },
          },
        },
      ],
    });
  };

  handleCaseListImpressionTracking = () => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    dispatchTrack({
      operation: TRACKING_OPERATION.IMPRESSION,
      section: TRACKING_SECTION[TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_CASE_LIST],
      target: TRACKING_TARGET[TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_CASE_LIST],
      data: {
        chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        bot_id: kbBotId,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
        case_selector_scrolls: this.caseSelectorScrolls,
        case_selector_scroll_to_end: this.caseSelectorScrollToEnd,
      },
    });

  };

  handleButtonClickTracking = (index: number) => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    const trackingData = {
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_type: buttonType[index],
      button_text: btnContent[index],
      button_id: buttonId[index] || '',
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      bot_id: kbBotId,
      case_count: enquiryCaseCurSize,
    };

    trackingHandler({
      trackingname: TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_SELECTION_BUBLE,
      trackingdata: trackingData,
    });
  };

  handlePopupCloseTracking = () => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    const trackingData = {
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      bot_id: kbBotId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      case_selector_scrolls: this.caseSelectorScrolls,
      case_selector_scroll_to_end: this.caseSelectorScrollToEnd,
    };

    trackingHandler({
      trackingname: TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_CLOSE,
      trackingdata: trackingData,
    });
  };

  handleCaseSelectTracking = (caseItem: CaseItem) => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    const trackingData = {
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      bot_id: kbBotId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      location: caseItem.index,
      case_id: caseItem.case_id,
      case_selector_scrolls: this.caseSelectorScrolls,
      case_selector_scroll_to_end: this.caseSelectorScrollToEnd,
      order_id: caseItem.order_sn,
    };

    trackingHandler({
      trackingname: TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_SELECT_CASE,
      trackingdata: trackingData,
    });
  };

  handleCaseDetailTracking = (caseItem: CaseItem) => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    const trackingData = {
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      bot_id: kbBotId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      location: caseItem.index,
      case_id: caseItem.case_id,
      case_selector_scrolls: this.caseSelectorScrolls,
      case_selector_scroll_to_end: this.caseSelectorScrollToEnd,
      order_id: caseItem.order_sn,
    };

    trackingHandler({
      trackingname: TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_CASE_DETAIL,
      trackingdata: trackingData,
    });
  };

  handleCaseDetailFromChatTracking = (caseItem: CaseItem) => {
    const { initStore, isHistory, historySessionId, historyDialogueId, dialogueId, enquiryCaseCurSize, kbBotId, buttonType, btnContent, buttonId } = this.props;

    const trackingData = {
      chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      bot_id: kbBotId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
      case_id: caseItem.case_id,
      order_id: caseItem.order_sn,
    };

    trackingHandler({
      trackingname: TRACKING_TYPE.LIVE_AGENT_CASE_SELECTOR_CASE_DETAIL_FROM_CHAT,
      trackingdata: trackingData,
    });
  };

  handleCaseClick = async () => {
    const { enquiryCaseMaxSize } = this.props;
    const params = {
      page_no: 1,
      page_size: enquiryCaseMaxSize,
    };
    this.hasMoreCase = true;
    this.caseSelectorScrollToEnd = HAS_SCROLL_TO_END.FALSE;
    this.handleButtonClickTracking(0);
    const { case_items } = await (API).queryUserCaseList(params).catch(() => {});
    this.setState({
      active: true,
      caseList: case_items || [],
      page_no: 2,
    });
    this.handleCaseListImpressionTracking();
  };

  renderRedirection() {
    const { dialogueId } = this.props;
    const props = {
      dialogueId: dialogueId,
      msgContent: getTrans('live_agent_offline_text'),
      buttons: [
        {
          text_key: 'chat_send_your_enquiry',
          // refer to handleRedirectionBtnClick
          // refer to REDIRECTION_URLS
          // no key from config api and template api
          uri_key: getWebFormKey(),
          uri_extra: {},
          // webview
          extraParams: { popSelf: 1 }, // 关闭当前页面
        },
      ],
    };

    return (
      <Redirection {...props}/>
    );
  }

  renderMsg() {

    const { dialogueId } = this.props;

    const props = {
      dialogueId,
      content: getTrans('live_agent_offline_text'),
      from: DIALOGUE_FROM.BOT,
    };

    return (
      <Msg {...props} />
    );
  }

  renderLiveUnAvailable() {
    const dialogueContent = hasWebForm() ? this.renderRedirection() : this.renderMsg();
    return dialogueContent;
  }

  render() {
    const {
      msgContent,
      btnContent,
      agentStore,
      isDisabled,
      disabledBtn,
      passedRef,
      buttonClassName,
      showPolicy,
      isKbRichText,
      isCaseSelect,
      // enquiryCaseNum,
      enquiryCaseCurSize,
      enquiryCaseMaxSize,
      dialogueId,
      dialogueType,
      live_agent_pre_check_inbound = {},
    } = this.props;

    const {
      live_chat_pre_check_inbound = IsAnyLiveAgentAvailableEnum.Available,
      virtual_call_pre_check_inbound = IsAnyLiveAgentAvailableEnum.Available,
    } = live_agent_pre_check_inbound;
    const { loadingInAgent, inAgent } = agentStore;
    const trackingdata = JSON.stringify(this.trackingdata);
    const enquiryCaseDisplayNum = enquiryCaseCurSize > enquiryCaseMaxSize ? `${enquiryCaseMaxSize}+` : enquiryCaseCurSize;

    // the live chat and virtual call both are unavailable
    // render the Msg based on platform and config
    if (shouldApplyLiveAgentAvailbility() && !(live_chat_pre_check_inbound || virtual_call_pre_check_inbound)) {
      return this.renderLiveUnAvailable();
    }

    return <div className={PREFIX}>
      {
        isCaseSelect ? (
          <>
            <Msg content={msgContent} isKbRichText={isKbRichText} />
            <ButtonGroup
              buttons={[
                {
                  text: `${btnContent[0]} (${enquiryCaseDisplayNum})`, type: 'primary', buttonId: '1234',
                  disabled: this.state.isButtonsDisabled,
                  onClick: async () => {
                    this.handleCaseClick();
                  },
                },
                {
                  text: `${btnContent[1]}`, type: 'secondary-outlined', buttonId: '3456',
                  disabled: this.state.isButtonsDisabled,
                  onClick: () => {
                    this.handleButtonClickTracking(1);
                    this.setState({ isButtonsDisabled: true });
                    // 用来使btn进线后依然可以置灰
                    disableDialogueChannelOptionButton();
                    agentStore.UPDATE_AGENT_CASE_FIELD({ userExistCase: true });
                    this.handleJumpClick();
                  },
                },
              ]}
            />
            <Popup
              showCloseIcon
              active={this.state.active}
              title={getTrans('case_select_enquiry')}
              titleClassName="enquiryListPopupTitle"
              onClose={() => {
                this.setState({ active: false });
                this.handlePopupCloseTracking();
              }}
            >
              <InfiniteScroll
              // 如只有一个case， 浮窗需自适应大小； 如有2个case 及以上，浮窗固定高度；
                style={enquiryCaseCurSize >= 2 ? { height: '25.8rem', backgroundColor: '#F5F5F5', padding: '0.75rem' } : { height: 'auto', backgroundColor: '#F5F5F5', padding: '0.75rem' }}
                showLoading={true}
                onLoadMore={() => {
                  this.handleLoadMore(enquiryCaseMaxSize);
                }}
              >
                <div
                  ref={this.domRef}
                >
                  {this.state.caseList.map((caseItem) => (
                    <div key={caseItem.case_id} style={{ marginBottom: '8px' }}>
                      <EnquiryCaseCard
                        key={caseItem.case_id}
                        caseItem = {caseItem}
                        hasOrderInfo={caseItem.order_sn !== ''}
                        onCaseCardClick={() => {
                          this.handleCaseDetailTracking(caseItem);
                          this.handleCaseCardClick(caseItem);
                        }}
                        onEnquiryClick={() => {
                          this.handleCaseSelectTracking(caseItem);
                          this.setState({
                            active: false,
                            isButtonsDisabled: true,
                          });
                          // 用来使btn进线后依然可以置灰
                          disableDialogueChannelOptionButton();
                          this.showAndSaveMessage('user', getTrans('case_previous_enquiry'), caseItem.order_sn !== '', caseItem);
                          agentStore.UPDATE_AGENT_CASE_FIELD({
                            userType: caseItem.user_type_id,
                            enquiryType: caseItem.enquiry_type_id,
                            userTypeName: caseItem.user_type_name,
                            inboundOrderSn: caseItem.order_sn,
                            reasonCodeL1Id: caseItem.reason_code,

                            userExistCase: true,
                            caseId: caseItem.case_id,
                            firstEnquiryTime: caseItem.first_enquiry_time,
                            caseUpdateTime: caseItem.case_update_time,
                            reasonCode: caseItem.reason_code,
                            orderSN: caseItem.order_sn,
                            orderItemName: caseItem.order_item_name,
                            orderItemFirstImageUrl: caseItem.order_item_first_image_url,
                            userTypeLabel: caseItem.userTypeLabel,
                          });
                          startAgent(dialogueId, '', dialogueType);
                        }}
                      />
                    </div>
                  ))}
                </div>
              </InfiniteScroll>
            </Popup>
          </>
        ) : (
          <>
            {showPolicy
              ? <div className="msg-container-wrapper">
                <div className="content">
                  {`${msgContent} `}
                  <a onClick={this.handleBankJump}>{getTrans(BANK_POLICY_CONTENT)}</a>
                </div>
              </div>
              : (
                <Msg content={msgContent} isKbRichText={isKbRichText} />
              )}
            {loadingInAgent || inAgent || isDisabled ? null : (
              <SingleButton
                disabled={disabledBtn}
                passedRef={passedRef}
                trackingname={this.trackingname}
                trackingdata={trackingdata}
                className={buttonClassName}
                handleClick={this.handleJumpClick}
              >
                <ReactSVG src={Chat} style={{ display: 'inline-block', verticalAlign: 'sub', marginRight: 5, height: '16px' }} /><span>{btnContent}</span>
              </SingleButton>
            )}
          </>
        )
      }
    </div>;
  }
}
